import script from "./accessory.vue?vue&type=script&setup=true&lang=ts"
export * from "./accessory.vue?vue&type=script&setup=true&lang=ts"

import "./accessory.vue?vue&type=style&index=0&id=2d8232be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8232be"]])

export default __exports__